import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import CookieConsent from "react-cookie-consent";

// STORAGE
import Storage from "./helpers/Storage";

//REDUX
import { Provider } from "react-redux";
import store from "./redux/store";

// SASS
import "antd/dist/antd.css";
import "./styles/theme.scss";

// COMPONENTS
import Loader from "./components/util/Loader";

const Home = lazy(() => import("./pages/home/home.page"));
const Cart = lazy(() => import("./pages/cart/cart.page"));
const Manual = lazy(() => import("./pages/manual/manual.page"));
const FrequentQuestion = lazy(() =>
  import("./pages/frequent-questions/frequent-questions.page")
);
const Catalog = lazy(() => import("./pages/catalog/catalog.page"));
const BrandPage = lazy(() => import("./pages/brand/brand.page"));
const MomentPage = lazy(() => import("./pages/moment/moment.page"));
const ProfilePage = lazy(() => import("./pages/profile/profile.page"));
const DetailPage = lazy(() => import("./pages/detail/detail.page"));
const PackPage = lazy(() => import("./pages/pack/pack.page"));
const HistoryPage = lazy(() => import("./pages/history/history.page"));
const thankPage = lazy(() => import("./pages/thank/thank.page"));
const DataPolicyPage = lazy(() => import("./pages/policy/datapolicy.page"));
const CookiePolicyPage = lazy(() => import("./pages/policy/cookiepolicy.page"));
const TermPage = lazy(() => import("./pages/policy/term.page"));
const RecoveryPage = lazy(() => import("./pages/recovery/recovery.page"));
const NoCoveregePage = lazy(() => import("./pages/nocoverege/nocoverege.page"));
const MenuFooter = lazy(() => import("./components/layout/components/header/MenuFooter"));

// COMPONENTES
const App = (props) => {
  const NotFoundRedirect = () => <Redirect to="/" />;

  return (
    <Suspense fallback={<Loader />}>
      <Provider store={store}>
        <BrowserRouter basename="/hogares">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/catalogo/:categoria" component={Catalog} />
            <Route
              exact
              path="/catalogo/:categoria/:producto"
              component={DetailPage}
            />
            <Route exact path="/marca/:seccion" component={BrandPage} />
            <Route exact path="/momentos/:seccion" component={MomentPage} />
            <Route exact path="/pack/:pack" component={PackPage} />
            <Route exact path="/manual" component={Manual} />
            <Route
              exact
              path="/preguntas-frecuentes"
              component={FrequentQuestion}
            />
            <Route
              exact
              path="/politicas-cookie"
              component={CookiePolicyPage}
            />
            <Route exact path="/politicas-datos" component={DataPolicyPage} />
            <Route exact path="/terminos-y-condiciones" component={TermPage} />
            <Route exact path="/carrito" component={Cart} />
            <Route exact path="/recuperar-clave" component={RecoveryPage} />
            <Route exact path="/no-cobertura" component={NoCoveregePage} />
            <PrivateRoute exact path="/pedidos" component={HistoryPage} />
            <PrivateRoute exact path="/datos" component={ProfilePage} />
            <Route exact path="/thank-you-page/:orden" component={thankPage} />
            <Route exact path="/thank-you-page" component={thankPage} />
            <Route exact path="/menu_footer" component={MenuFooter} />

            <Route component={NotFoundRedirect} />
          </Switch>
        </BrowserRouter>

        <CookieConsent
          style={{
            paddingBottom: "0px",
            fontSize: "1.0rem",
          }}
          location="bottom"
          buttonText="ACEPTAR"
        >
          <p>
            Utilizamos cookies para mejorar la navegación en el sitio.
            <a
              style={{
                marginLeft: "10px",
                color: "white",
                borderBottom: "1px solid white",
              }}
              href={"/politicas-cookie"}
            >
              Mas Información
            </a>
          </p>
        </CookieConsent>
      </Provider>
    </Suspense>
  );
};

// RUTAS PRIVADAS
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      Storage.getToken() ? <Component {...props} /> : <Redirect to="/" />
    }
  />
);

export default App;
